// extracted by mini-css-extract-plugin
module.exports = {"logo":"Header_logo__kRWBG","reactLogo":"Header_reactLogo__2aE81"};